import {defineStore} from 'pinia'
const navigationVisibilities = {
    isVisibilitySet: false,
    showCreditLink: false,
    showFacilitatorGuideLink: false,
    showExhibitorsLink: false,
    showMaterialsLink: false,
    showMyScheduleLink: false,
    showPartnersLink: false,
    showPresentersLink: false,
    showScheduleLink: false,
    showVenuesLink: false,
    showPosterLink:false,
}

export const useApiStore = defineStore('api', {
    state: () => ({
        allowScheduleChanges: false,
        baseUrl: process.env.VUE_APP_API_ENDPOINT,
        ceCreditTypes: null,
        currentAttendee: null,
        currentEvent: null,
        currentPresenter: null,
        currentRegistration: null,
        dateRange: null,
        displayName: '',
        events: null,
        facilitatorGuide: false,
        filterCeCreditType: '',
        filterFormat: '',
        filterText: '',
        filterTopic: '',
        filterType: '',
        filterVenue: '',
        isAdmin: false,
        isNewInstance: true,
        isPaidForCurrentEvent: false,
        isRegisteredForCurrentEvent: false,
        isWaitListedForCurrentEvent: false,
        isStaff: false,
        leas: null,
        mySchedule: null,
        navigationVisibilities: navigationVisibilities,
        oid: null,
        pastEvents: null,
        paymentData: null,
        paymentToken: null,
        presenters: null,
        topics: null,
        venues: null,
        topPastEvents: null,
    }),
    getters: {
        buildUrl: (state) => {
            return (path) => state.baseUrl + path
        },
    },
    actions: {
        removeSessionAsset(sessionId, materialId) {
            const dropAsset = (session) => {
                if (session.id === sessionId) {
                    session.assets = (session.assets || []).filter(
                        (asset) => asset.id !== materialId,
                    )
                }
            }
            // mySchedule / currentEvent.sessions may not be loaded if the
            // delete is triggered from a view that didn't populate them
            // (e.g. PresenterView). Skip the missing list rather than crash.
            if (this.mySchedule && Array.isArray(this.mySchedule.sessions)) {
                this.mySchedule.sessions.forEach(dropAsset)
            }
            if (this.currentEvent && Array.isArray(this.currentEvent.sessions)) {
                this.currentEvent.sessions.forEach(dropAsset)
            }
        },
        // Force the next visit to the schedule, presenter view, or My Schedule
        // to refetch from the server. Used after an asset upload OR delete so
        // cached session lists reflect the change instead of rendering stale
        // material rows.
        invalidateSessionAssetCaches() {
            const expired = new Date(0)
            if (this.currentEvent) {
                this.currentEvent.expires = expired
            }
            if (this.currentPresenter) {
                this.currentPresenter.expires = expired
            }
            if (this.mySchedule) {
                this.mySchedule.expires = expired
            }
        },
        addSessionAsset(sessionId, assets) {
            const addFiles = (session) => {
                if (session.id === sessionId) {
                    const incoming = Array.isArray(assets) ? assets : [assets]
                    session.assets = (session.assets || []).concat(incoming)
                }
            }
            // mySchedule / currentEvent.sessions may not be populated yet
            // when the caller navigated straight to /materialview/:sessionId
            // without visiting the schedule first. Skip rather than crash —
            // the asset is already saved server-side; the cached lists will
            // pick it up the next time they're reloaded.
            if (this.mySchedule && Array.isArray(this.mySchedule.sessions)) {
                this.mySchedule.sessions.forEach(addFiles)
            }
            if (this.currentEvent && Array.isArray(this.currentEvent.sessions)) {
                this.currentEvent.sessions.forEach(addFiles)
            }
        }
    }
})
